import styled from 'styled-components';
import { dialog } from "../../styles";
export default styled.div.attrs({
  role: 'presentation'
}).withConfig({
  displayName: "Dialog",
  componentId: "oi4r8h-0"
})(["", ";width:600px;"], function (props) {
  return dialog(props.theme.dialogConfirmation === 'dark');
});